import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  vouchersService,
  PrioritiseBrandsRequest,
  PrioritiseBrandsResponse,
} from '@aslanpay/portal-common-lib';

const useUpdateBrandPriority = ({
  onSuccess,
  onError,
}: UseMutationOptions<PrioritiseBrandsResponse, Error, PrioritiseBrandsRequest>) => {
  return useMutation<PrioritiseBrandsResponse, Error, PrioritiseBrandsRequest>(
    (payload: PrioritiseBrandsRequest) => vouchersService.prioritiseBrands(payload),
    { onSuccess, onError }
  );
};

export default useUpdateBrandPriority;
